import { MetaPixel } from "./components/MetaPixel";
import { UtmifyTracking } from "./components/UtmifyTracking";
import { Hero } from "./components/Hero";
import { BeforeAfter } from "./components/BeforeAfter";
import { Identify } from "./components/Identify";
import { Includes } from "./components/Includes";
import { Tomos } from "./components/Tomos";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { About } from "./components/About";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { FloatingCta } from "./components/FloatingCta";
export function App() {
  return <div className="w-full bg-white text-[#0f2547]" data-id="element-0" data-mp="2whxd1y9zzwht">
      <MetaPixel data-id="element-1" data-mp="28te2td7e19n3" />
      <UtmifyTracking data-id="element-2" data-mp="28suw6sn6u7od" />
      <main className="w-full" data-id="element-3" data-mp="28sbe9bxjfjac">
        <Hero data-id="element-4" data-mp="23vunsb2v8su3" />
        <BeforeAfter data-id="element-5" data-mp="23u9t8lgjx9w8" />
        <Identify data-id="element-6" data-mp="23utas12ahw9q" />
        <Includes data-id="element-7" data-mp="23t8g8bfz6dbv" />
        <Tomos data-id="element-8" data-mp="3ijxokogyjwiu" />
        <Bonuses data-id="element-9" data-mp="3ikha0f5th31m" />
        <Offer data-id="element-10" data-mp="3iiwf2oflbi38" />
        <Guarantee data-id="element-11" data-mp="3ijfvu1ti80fo" />
        <Testimonials data-id="element-12" data-mp="3ihv048vgebg8" />
        <About data-id="element-13" data-mp="3mlj6io8cn0zw" />
        <Faq data-id="element-14" data-mp="3ml1234bj9ggw" />
        <FinalCta data-id="element-15" data-mp="3mkhm3t5g125i" />
      </main>
      <FloatingCta data-id="element-16" data-mp="3mjq3rk0ux0x6" />
    </div>;
}